import { render, staticRenderFns } from "./AlarmNotification.vue?vue&type=template&id=420ca628&scoped=true"
import script from "./AlarmNotification.vue?vue&type=script&lang=js"
export * from "./AlarmNotification.vue?vue&type=script&lang=js"
import style0 from "./AlarmNotification.vue?vue&type=style&index=0&id=420ca628&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "420ca628",
  null
  
)

export default component.exports